import { render, staticRenderFns } from "./DeepSignOverview.vue?vue&type=template&id=3a4c854a&scoped=true"
import script from "./DeepSignOverview.vue?vue&type=script&lang=ts"
export * from "./DeepSignOverview.vue?vue&type=script&lang=ts"
import style0 from "./DeepSignOverview.vue?vue&type=style&index=0&id=3a4c854a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c854a",
  null
  
)

export default component.exports